import React from 'react';
import { X, Calendar } from 'lucide-react';

const DateInput = ({ field, onChange, formData, setFormData, errorMessage }) => {
    const baseInputStyles = "w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:bg-gray-800 dark:text-gray-50 dark:placeholder-gray-400";

    return (
        <>
            <style>
                {`
          /* Hide default calendar picker icon */
          input[type="date"]::-webkit-calendar-picker-indicator {
            opacity: 0;
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            cursor: pointer;
          }

          input[type="date"]::-webkit-inner-spin-button,
          input[type="date"]::-webkit-outer-spin-button {
            -webkit-appearance: none;
            margin: 0;
          }

          /* Firefox */
          input[type="date"]::-moz-calendar-picker-indicator {
            opacity: 0;
          }

          /* Edge */
          input[type="date"]::-ms-clear,
          input[type="date"]::-ms-reveal {
            display: none;
          }

          /* Remove the default arrow in IE */
          input[type="date"]::-ms-expand {
            display: none;
          }

          /* Ensure the input text doesn't overlap with our custom icon */
          input[type="date"] {
            position: relative;
            z-index: 1;
          }
        `}
            </style>
            <div className="relative">
                <input
                    type="date"
                    name={field.id}
                    value={formData[field.id] || ''}
                    onChange={(e) => {
                        onChange(e);
                    }}
                    required={field.required}
                    className={`${baseInputStyles} pr-10`}
                />
                <div className="pointer-events-none absolute right-8 top-1/2 -translate-y-1/2 z-10">
                    <Calendar className="h-4 w-4 text-gray-500 dark:text-gray-400" />
                </div>
                {formData[field.id] && (
                    <button
                        type="button"
                        onClick={() => {
                            setFormData(prev => ({
                                ...prev,
                                [field.id]: ''
                            }));
                        }}
                        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200 focus:outline-none z-10"
                        aria-label="Clear date"
                    >
                        <X className="w-4 h-4" />
                    </button>
                )}
            </div>
            {errorMessage}
        </>
    );
};

export default DateInput;
